import { cva } from 'class-variance-authority';

import { cn } from '@/utils';

const chipVariants = cva(
	'inline-flex h-7 items-center justify-center whitespace-nowrap rounded px-2 text-xs capitalize leading-5',
	{
		variants: {
			bgColor: {
				default: 'bg-gray-900/10',
				info: 'bg-sky-100',
				success: 'bg-green-background',
				error: 'bg-red-background',
				warning: 'bg-orange-background',
				caution: 'bg-orange-background',
				retry: 'bg-red-background'
			},
			color: {
				white: 'text-white',
				black: 'text-black'
			}
		},
		defaultVariants: {
			bgColor: 'default',
			color: 'white'
		}
	}
);

function Chip({ children, bgColor, color, className }) {
	return (
		<div
			className={cn(
				chipVariants({
					bgColor,
					color,
					className
				})
			)}
		>
			{children}
		</div>
	);
}

export default Chip;
